import axios from 'axios'
import config from '../config/Config'
import { serviceRequest, serviceRequestForFileUpload } from './ServiceRequest'
const {
  BASE_URL,
  BASE_URL_SIT,
  GET_APP_MENU_ALL,
  GET_USER_DETAILS_ID,
  PUT_USER_DETAILS_ID,
  PUT_USER_DETAILS_ID_CAMUNDA,
  GET_USER_DETAILS_ALL,
  GET_ROLES_ALL,
  PUT_USER_GROUPS_ID,
  GET_USER_GROUPS_ALL,
  GET_TASKLIST_ID,
  GET_TASKLIST_ALL,
  GET_TASKLOG_ID,
  POST_TASKLOG_ID,
  GET_USER_INFO,
  GET_USER_INFO_OTHER,
  USER_V2,
  PUT_CLAIM_TASK_CAMUNDA,
  GET_DASHBOARD_STATUS_CAMUNDA,
  EVENT_DASHBOARD_GET_CAMUNDA,
  POST_ATTACHMENT,
  PUT_COMPLETE_TASK_CAMUNDA,
  PUT_REJECT_TASK_CAMUNDA,
  PRODUCT_HIERARCHY_LIST_GET,
  PATCH_RANGERESET_EVENTS,
  GET_RANGERESET_EVENTS,
  DELETE_RANGERESETS,
  GET_RESET_TYPES,
  GET_PLANOGRAM_CLASSES,
  GET_WASTAGE_RANGES,
  CREATE_EVENTS_CAMUNDA,
  GET_EVENTDETAILS_BY_ID,
  PATCH_DELETE_RANGERESETS,
  PUBLISH_CAMUNDA_EVENT,
  PUBLISH_SELECTED_CAMUNDA_EVENT,
  PUT_CAMUNDA_CLAIM,
  DELETE_EVENTS_CAMUNDA,
  PUT_CAMUNDA_MILESTONE_UPDATE,
  POST_RANGE_RESET_EVENT_ATTACHMENT,
  GET_CONFIG,
  GET_RANGE_BY_RANGEID,
  GET_PRODUCT_SERVICE,
  GET_PRODUCT_SUPPLIER_SERVICE,
  GET_SUPPLIER_SERVICE,
  GET_PRODUCT_COMPOSITION_SERVICE,
  GET_RANGE_SUMMARY_BY_ID_MIN,
  GET_SUPPLIER_BY_SUPPLIER_AND_SITE,
  GET_LOCATIONS,
  PATCH_RANGERESET_ITEMS,
  GET_STORE_DEPOT_FROM_RANGE_SUMMARY_BY_ID_MIN,
  GET_LOCATIONS_SERVICE,
  GET_RANGE_PLANOGRAM_ERROR,
  DELETE_RAF_ITEM,
  PATCH_RANGE_PLANOGRAM_ERROR,
  DELETE_RANGE_PLANOGRAM_ERROR,
  DELETE_PLANO_ALL,
  GET_CT14_TO_CT17_TASKS,
  GET_EXCEPTION_DETAILS,
  POST_EXCEPTION_DETAILS,
  POST_EXCEPTION_ELIGIBILITY,
  GET_EXCEPTION_DETAILS_CAMUNDA,
  POST_EXCEPTION_DETAILS_CAMUNDA,
  APPID,
} = config


export const userV2Login = (idToken) => {
  const data = new URLSearchParams()
  data.append('grant_type', 'password')
  data.append('id_token', idToken)
  return axios({
    method: 'POST',
    url: `${BASE_URL_SIT}${USER_V2}?apikey=${APPID}`,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'Cache-Control': 'no-cache',
    },
    data,
  })
}

export const deletePlanoAll = async (eventId) => {
  let url = `${BASE_URL}${DELETE_PLANO_ALL}`
  url = url.replace('{eventId}', eventId)
  return serviceRequest(url, 'DELETE', undefined)
}

export const postTaskLogsAPI = (req) => {
  const url = `${BASE_URL}${POST_TASKLOG_ID}`
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'POST', reqBody)
}

export const postFileAttachmentAPI = (req, userId) => {
  let url = `${BASE_URL}${POST_ATTACHMENT}`
  url = url.replace('{userId}', userId)
  return serviceRequestForFileUpload(url, 'POST', req)
}

export const putUserDetailsAPI = (req) => {
  let url = `${BASE_URL}${PUT_USER_DETAILS_ID}`
  url = url.replace('{userId}', req.user.employeeId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PUT', reqBody)
}

export const putUserDetailsCamundaAPI = (req) => {
  let url = `${BASE_URL}${PUT_USER_DETAILS_ID_CAMUNDA}`
  url = url.replace('{userId}', req.user.employeeId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PUT', reqBody)
}

export const getUserDetailsAPI = (userId) => {
  const url = `${BASE_URL_SIT}${GET_USER_INFO}`
  return serviceRequest(url, 'GET', undefined)
}

export const colleagueV2Login = (accesToken) => {
  return axios({
    method: 'GET',
    url: `${BASE_URL}${GET_USER_INFO}?apikey=${APPID}`,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accesToken}`,
    },
  })
}

export const getRoleAPI = () => {
  const url = `${BASE_URL}${GET_ROLES_ALL}`
  const params = 'limit=1000'
  return serviceRequest(url, 'GET', undefined, params)
}

export const getStatusCamundaAPI = () => {
  let empId = ''
  const userV2Response = JSON.parse(
    localStorage?.getItem('_GresponseV2')
  )
  if (userV2Response) {
    empId = userV2Response?.empId
  }
  let url = `${BASE_URL}${GET_DASHBOARD_STATUS_CAMUNDA}`
  const params = 'limit=1000'
  url = url.replace('{userId}', empId)
  return serviceRequest(url, 'GET', undefined, params)
}

export const getStatusEventCamundaAPI = () => {
  let empId = ''
  const userV2Response = JSON.parse(
    localStorage?.getItem('_GresponseV2')
  )
  if (userV2Response) {
    empId = userV2Response?.empId
  }
  let url = `${BASE_URL}${EVENT_DASHBOARD_GET_CAMUNDA}`
  const params = 'limit=1000'
  url = url.replace('{userId}', empId)
  url = url.replace('{processDefKey}', 'hbtwEventRequestHandler')
  return serviceRequest(url, 'GET', undefined, params)
}

export const getStatusNewCamundaAPI = (empId, summary) => {
  let url = `${BASE_URL}${GET_DASHBOARD_STATUS_CAMUNDA}`
  const params = `filter=${summary}&offset=0&limit=0`
  url = url.replace('{userId}', empId)
  return serviceRequest(url, 'GET', undefined, params)
}

export const getStatusWithLimitNewCamundaAPI = (empId, summary) => {
  let url = `${BASE_URL}${GET_DASHBOARD_STATUS_CAMUNDA}`
  const params = `filter=${summary}&offset=0&limit=1000`
  url = url.replace('{userId}', empId)
  return serviceRequest(url, 'GET', undefined, params)
}

export const getStatusEventCamundaAPINew = (
  empId,
  userRole,
  tradingGrp,
  filter
) => {
  let url = `${BASE_URL}${EVENT_DASHBOARD_GET_CAMUNDA}`
  const params = `limit=10000&userRole=${userRole}&tradingGrp=${tradingGrp}&filter=${filter}`
  url = url.replace('{userId}', empId)
  url = url.replace('{processDefKey}', 'hbtwEventRequestHandler')
  return serviceRequest(url, 'GET', undefined, params)
}

export const getAppsAPI = () => {
  const url = `${BASE_URL}${GET_APP_MENU_ALL}`
  const params = 'limit=1000'
  return serviceRequest(url, 'GET', undefined, params)
}

export const getUserAPI = (userId) => {
  let url = `${BASE_URL}${GET_USER_DETAILS_ID}`
  url = url.replace('{userId}', userId)
  const params = 'limit=1000&statusIn=A,I,D'
  return serviceRequest(url, 'GET', undefined, params)
}

export const getUserIdAPI = (userId) => {
  let url = `${BASE_URL}${GET_USER_DETAILS_ID}`
  url = url.replace('{userId}', userId)
  const params = 'limit=1000&statusIn=I,D'
  return serviceRequest(url, 'GET', undefined, params)
}

export const getUserForAllStatusAPI = (userId) => {
  let url = `${BASE_URL}${GET_USER_DETAILS_ID}`
  url = url.replace('{userId}', userId)
  const params = 'limit=1000'
  return serviceRequest(url, 'GET', undefined, params)
}

export const getUserGroupAPI = () => {
  const url = `${BASE_URL}${GET_USER_GROUPS_ALL}`
  const params = 'limit=1000'
  return serviceRequest(url, 'GET', undefined, params)
}

export const getUserGroupActiveAPI = () => {
  const url = `${BASE_URL}${GET_USER_GROUPS_ALL}`
  const params = 'limit=1000&statusIn=A'
  return serviceRequest(url, 'GET', undefined, params)
}

export const getUserGroupAPIWithGroupId = (groupIdIn) => {
  let url = `${BASE_URL}${GET_USER_GROUPS_ALL}`
  const params = `groupIdIn=${groupIdIn}`
  return serviceRequest(url, 'GET', undefined, params)
}

export const putUserGroupAPI = (req, groupId) => {
  let url = `${BASE_URL}${PUT_USER_GROUPS_ID}`
  url = url.replace('{groupId}', groupId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PUT', reqBody)
}

export const putClaimTaskAPI = (req, taskId) => {
  let url = `${BASE_URL}${PUT_CLAIM_TASK_CAMUNDA}`
  url = url.replace('{taskId}', taskId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PUT', reqBody)
}

export const putCompleteTaskAPI = (req, taskId) => {
  let url = `${BASE_URL}${PUT_COMPLETE_TASK_CAMUNDA}`
  url = url.replace('{taskId}', taskId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PUT', reqBody)
}

export const putRejectTaskAPI = (req, businessKey) => {
  let url = `${BASE_URL}${PUT_REJECT_TASK_CAMUNDA}`
  url = url.replace('{businessKey}', businessKey)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PUT', reqBody)
}

export const getProductHierarchyListAPI = (nodetype) => {
  let url = `${BASE_URL}${PRODUCT_HIERARCHY_LIST_GET}`
  url = url.replace('{nodetype}', nodetype)
  return serviceRequest(url, 'GET', undefined)
}

export const getAllUsersAPI = () => {
  const url = `${BASE_URL}${GET_USER_DETAILS_ALL}`
  const params = 'limit=1000&statusIn=A,I,D'
  return serviceRequest(url, 'GET', undefined, params)
}

export const getAllActiveUsersAPI = () => {
  const url = `${BASE_URL}${GET_USER_DETAILS_ALL}`
  const params = 'limit=1000&statusIn=A'
  return serviceRequest(url, 'GET', undefined, params)
}

export const getUsersAPIByEmailAndRole = (roleId, emailId) => {
  const url = `${BASE_URL}${GET_USER_DETAILS_ALL}`
  const params = `limit=1000&roleIdIn=${roleId}&statusIn=A&emailIdIn=${emailId}`
  return serviceRequest(url, 'GET', undefined, params)
}

export const getUsersAPIByRole = (roleId, tradingGroup = '') => {
  const url = `${BASE_URL}${GET_USER_DETAILS_ALL}`
  let params = `limit=1000&roleIdIn=${roleId}&statusIn=A`

  if (tradingGroup !== '') {
    params += `&filter=true&groupIdIn=${tradingGroup}`
  }

  return serviceRequest(url, 'GET', undefined, params)
}

export const getUsersAPIByRolWithStatusA = (roleId) => {
  const url = `${BASE_URL}${GET_USER_DETAILS_ALL}`
  const params = `limit=1000&roleIdIn=${roleId}&statusIn=A`
  return serviceRequest(url, 'GET', undefined, params)
}

export const getAllUsersWithGroupAPI = (groupId) => {
  const url = `${BASE_URL}${GET_USER_DETAILS_ALL}`
  const params = `limit=1000&groupIdIn=${groupId}&statusIn=A`
  return serviceRequest(url, 'GET', undefined, params)
}

export const getColleagueAPI = (id) => {
  let url = `${BASE_URL}${GET_USER_INFO_OTHER}`
  url = url.replace('{userId}', id)
  return serviceRequest(url, 'GET', undefined)
}

export const getTasklistsAllAPI = (userId) => {
  let url = `${BASE_URL}${GET_TASKLIST_ALL}`
  const params = `limit=1000&referenceNumberIn=${userId}&stateIn=Pending,New`
  return serviceRequest(url, 'GET', undefined, params)
}

export const getTasklistsAPI = (requestId) => {
  let url = `${BASE_URL}${GET_TASKLIST_ID}`
  url = url.replace('{requestId}', requestId)
 
  return serviceRequest(url, 'GET', undefined)
}

export const getTasklogsAPI = (requestId) => {
  let url = `${BASE_URL}${GET_TASKLOG_ID}`
  url = url.replace('{requestId}', requestId)
 
  return serviceRequest(url, 'GET', undefined)
}

export const getResetTypes = () => {
  let url = `${BASE_URL}${GET_RESET_TYPES}`
  return serviceRequest(url, 'GET', undefined)
}

export const getPlanogramClasses = () => {
  let url = `${BASE_URL}${GET_PLANOGRAM_CLASSES}`
 
  return serviceRequest(url, 'GET', undefined)
}

export const getWastageRanges = () => {
  let url = `${BASE_URL}${GET_WASTAGE_RANGES}`
  return serviceRequest(url, 'GET', undefined)
}

export const getRangeResetEvents = () => {
  let url = `${BASE_URL}${GET_RANGERESET_EVENTS}`
  const params = `versionIn=V2`
  return serviceRequest(url, 'GET', undefined, params)
}

export const patchRangeResetEvents = (
  req,
  duplicateValidation,
  bulkActionRole = ''
) => {
  let url = `${BASE_URL}${PATCH_RANGERESET_EVENTS}`

  let params = `duplicateValidation=${duplicateValidation}`
  if (bulkActionRole !== '') {
    params += `&eventBulkActionIn=${bulkActionRole}`
  }

  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PATCH', reqBody, params)
}

export const deleteRangeResets = (resetId) => {
  let url = `${BASE_URL}${DELETE_RANGERESETS}`
  url = url.replace('{rangeResetId}', resetId)
  return serviceRequest(url, 'DELETE', undefined)
}

export const patchUpdateRangeResets = (resetId, req) => {
  let url = `${BASE_URL}${PATCH_DELETE_RANGERESETS}`
  url = url.replace('{rangeResetId}', resetId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PATCH', reqBody)
}

export const createEventsCamunda = (eventId, req) => {
  let url = `${BASE_URL}${CREATE_EVENTS_CAMUNDA}`
  url = url.replace('{eventId}', eventId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PUT', reqBody)
}

export const publishEventsCamunda = (eventId, req) => {
  let url = `${BASE_URL}${PUBLISH_CAMUNDA_EVENT}`
  url = url.replace('{eventId}', eventId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PUT', reqBody)
}

export const publishSelectedEventsCamunda = (req) => {
  let url = `${BASE_URL}${PUBLISH_SELECTED_CAMUNDA_EVENT}`
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'POST', reqBody)
}

export const deleteEventsCamunda = (req) => {
  let url = `${BASE_URL}${DELETE_EVENTS_CAMUNDA}`
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'DELETE', reqBody)
}

export const getEventDetailsById = (eventId) => {
  let url = `${BASE_URL}${GET_EVENTDETAILS_BY_ID}`
  url = url.replace('{eventId}', eventId)
  return serviceRequest(url, 'GET', undefined)
}
export const getConfigType = (configType) => {
  let url = `${BASE_URL}${GET_CONFIG}`
  url = url.replace('{configType}', configType)
  return serviceRequest(url, 'GET', undefined)
}

export const claimEventsCamunda = (taskId, req) => {
  let url = `${BASE_URL}${PUT_CAMUNDA_CLAIM}`
  url = url.replace('{taskId}', taskId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PUT', reqBody)
}

export const putCamundaMileStoneUpdate = (eventId, req) => {
  let url = `${BASE_URL}${PUT_CAMUNDA_MILESTONE_UPDATE}`
  url = url.replace('{eventId}', eventId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PUT', reqBody)
}

export const postFileAttachmentRangeResetAPI = (req, eventId, taskId) => {
  let base = BASE_URL
  let url = `${base}${POST_RANGE_RESET_EVENT_ATTACHMENT}`
  url = url.replace('{rangeResetId}', eventId)
  const params = `taskIdIn=${taskId}`
  return serviceRequestForFileUpload(url, 'POST', req, params)
}
export const deleteFileAttachment = (fileNames) => {
  let url = `${BASE_URL}${POST_RANGE_RESET_EVENT_ATTACHMENT}`
  url = url.replace('rangeresets/{rangeResetId}', '@all')
  let param = 'fileIdIn='
  fileNames.map((file) => {
    if (file === fileNames[0]) {
      param = `${param}${file}`
    } else {
      param = `${param}&fileIdIn=${file}`
    }
    return null
  })
  return serviceRequest(url, 'DELETE', undefined, param)
}

export const postFileAttachmentRangeResetAPIForCTUpload = (
  req,
  eventId,
  uploadType,
  emailId
) => {
  let url = `${BASE_URL}${POST_RANGE_RESET_EVENT_ATTACHMENT}`
  url = url.replace('{rangeResetId}', eventId)
  const params = `uploadType=${uploadType}&emailId=${emailId}`
  return serviceRequestForFileUpload(url, 'POST', req, params)
}

export const postFileAttachmentRangeResetAPIForExceptionUpload = (
  req,
  eventId,
  uploadType
) => {
  let url = `${BASE_URL}${POST_RANGE_RESET_EVENT_ATTACHMENT}`
  url = url.replace('{rangeResetId}', eventId)
  const params = `uploadType=${uploadType}`
  return serviceRequestForFileUpload(url, 'POST', req, params)
}
export const getCamundaTaskDetailsCt14To17 = (rangeResetId, taskId) => {
  let url = `${BASE_URL}${GET_CT14_TO_CT17_TASKS}`
  url = url.replace('{eventID}', rangeResetId)
  url = url.replace('{taskName}', taskId)

  return serviceRequest(url, 'GET', undefined)
}

export const getRangeByRangeResetId = (rangeResetId) => {
  let url = `${BASE_URL}${GET_RANGE_BY_RANGEID}`
  url = url.replace('{rangeResetId}', rangeResetId)
  
  return serviceRequest(url, 'GET', undefined)
}
export const getProductServiceByItemnumber = (itemNumber, extraParams = '') => {
  let url = `${BASE_URL}${GET_PRODUCT_SERVICE}`
  url = url.replace('{itemNumber}', itemNumber)

  
  return serviceRequest(url, 'GET', undefined, extraParams)
}
export const getProductSupplierServiceByItemnumber = (itemNumber) => {
  let url = `${BASE_URL}${GET_PRODUCT_SUPPLIER_SERVICE}`
  url = url.replace('{itemNumber}', itemNumber)
  
  return serviceRequest(url, 'GET', undefined)
}
export const getSupplierServiceBySupplierId = (supplierId) => {
  let url = `${BASE_URL}${GET_SUPPLIER_SERVICE}`
  const params = `searchCriteria=&searchType=Site&supplier[in]=${supplierId}`
  return serviceRequest(url, 'GET', undefined, params)
}
export const getProductCompositionServiceByItemnumber = (itemNumber) => {
  let url = `${BASE_URL}${GET_PRODUCT_COMPOSITION_SERVICE}`
  url = url.replace('{itemNumber}', itemNumber)
  return serviceRequest(url, 'GET', undefined)
}
export const getLocationsServiceByItemnumber = (itemNumber) => {
  let url = `${BASE_URL}${GET_LOCATIONS_SERVICE}`
  url = url.replace('{itemNumber}', itemNumber)
  const params = 'limit=1000'
  return serviceRequest(url, 'GET', undefined, params)
}
export const getRangeByIdAndMinNumber = (rangeResetId, minNumber) => {
  let url = `${BASE_URL}${GET_RANGE_SUMMARY_BY_ID_MIN}`
  url = url.replace('{rangeResetId}', rangeResetId)
  url = url.replace('{MIN}', minNumber)
  return serviceRequest(url, 'GET', undefined)
}
export const getSupplierSearchByIdNameSupplierAndSite = (
  searchQuery,
  supplierType
) => {
  let url = `${BASE_URL}${GET_SUPPLIER_BY_SUPPLIER_AND_SITE}`
  const params = `searchCriteria=${searchQuery}&searchType=${supplierType}`
  return serviceRequest(url, 'GET', undefined, params)
}
export const getLocationsStoreCodeAPI = () => {
  const url = `${BASE_URL}${GET_LOCATIONS}`
  const params = 'limit=2000'
  return serviceRequest(url, 'GET', undefined, params)
}

export const patchRangeResetItems = (
  rangeResetId,
  req,
  isExceptionItem = false
) => {
  let url = `${BASE_URL}${PATCH_RANGERESET_ITEMS}`
  url = url.replace('{rangeResetId}', rangeResetId)
  let reqBody = `${JSON.stringify(req)}`
  let params = `isExceptionItem=${isExceptionItem}`
  return serviceRequest(url, 'PATCH', reqBody, params)
}

export const getRangeResetEventsStoreDepot = (
  rangeResetId,
  minNumber,
  storeOrDepot
  //ct // we dont need critical task in param as from ui we sending deraged location
) => {
  let url = `${BASE_URL}${GET_STORE_DEPOT_FROM_RANGE_SUMMARY_BY_ID_MIN}`
  url = url.replace('{rangeResetId}', rangeResetId)
  url = url.replace('{MIN}', minNumber)
  const params = `view=${storeOrDepot}`
  return serviceRequest(url, 'GET', undefined, params)
}

export const deleteRangeResetsPlanogramError = (rangeResetId, minNumber) => {
  let url = `${BASE_URL}${DELETE_RANGE_PLANOGRAM_ERROR}`
  url = url.replace('{rangeResetId}', rangeResetId)
  url = url.replace('{itemNumber}', minNumber)
  return serviceRequest(url, 'DELETE', undefined)
}

export const deleteRafItem = (rangeResetId, minNumber) => {
  let url = `${BASE_URL}${DELETE_RAF_ITEM}`
  url = url.replace('{rangeResetId}', rangeResetId)
  url = url.replace('{MIN}', minNumber)
  return serviceRequest(url, 'DELETE', undefined)
}

export const patchRangeResetPlanogramErrors = (
  rangeResetId,
  minNumber,
  req
) => {
  let url = `${BASE_URL}${PATCH_RANGE_PLANOGRAM_ERROR}`
  url = url.replace('{rangeResetId}', rangeResetId)
  url = url.replace('{itemNumber}', minNumber)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'PATCH', reqBody)
}
export const getRangeResetPlanogramErrors = (rangeResetId, minNumber) => {
  let url = `${BASE_URL}${GET_RANGE_PLANOGRAM_ERROR}`
  url = url.replace('{rangeResetId}', rangeResetId)
  url = url.replace('{itemNumber}', minNumber)
  
  
  return serviceRequest(url, 'GET', undefined)
}

//exception fetch
export const getExceptionDetails = (rangeresetId) => {
  let url = `${BASE_URL}${GET_EXCEPTION_DETAILS}`
  url = url.replace('{rangeresetId}', rangeresetId)
  return serviceRequest(url, 'GET', undefined)
}

export const putExceptionDetails = (rangeresetId, req) => {
  let url = `${BASE_URL}${POST_EXCEPTION_DETAILS}`
  url = url.replace('{rangeresetId}', rangeresetId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'POST', reqBody)
}
export const checkExceptionEligibilityDetails = (eventId) => {
  let url = `${BASE_URL}${POST_EXCEPTION_ELIGIBILITY}`
  url = url.replace('{eventId}', eventId)
  return serviceRequest(url, 'POST', undefined)
}

export const getExceptionDetailsCamunda = (eventId) => {
  let url = `${BASE_URL}${GET_EXCEPTION_DETAILS_CAMUNDA}`
  url = url.replace('{eventId}', eventId)
  return serviceRequest(url, 'GET', undefined)
}
export const postExceptionAddedCamundaApi = (eventId, req) => {
  let url = `${BASE_URL}${POST_EXCEPTION_DETAILS_CAMUNDA}`
  url = url.replace('{eventId}', eventId)
  let reqBody = `${JSON.stringify(req)}`
  return serviceRequest(url, 'POST', reqBody)
}